const aboutStyle = (theme) => ({
	heading: {
		textAlign: 'left',
		paddingTop: theme.spacing.unit * 4,
		color: '#d3d3d3'
	}
});
export default aboutStyle;



// WEBPACK FOOTER //
// ./src/styles/headerStyle.js